import {
  Box,
  Flex,
  IconButton,
  ScaleFade,
  useMediaQuery
} from '@chakra-ui/react'
import { FC, useRef, useState } from 'react'
import { FaAngleRight, FaAngleLeft } from 'react-icons/fa'
import Slider, { Settings } from 'react-slick'

export type SliderSettings = Settings

interface ICardSlider {
  isFilters?: boolean
}

const CardSlider: FC<ICardSlider> = ({ children, isFilters = true }) => {
  const sliderRef = useRef<Slider>(null)

  const [position, setPosition] = useState(0)

  const [isLargerThanHDWithFilters, _isDisplayingInBrowserWithFilters] =
    useMediaQuery(['(min-width: 1550px)', '(display-mode: browser)'])

  const [isLargerThanHD, _isDisplayingInBrowser] = useMediaQuery([
    '(min-width: 1240px)',
    '(display-mode: browser)'
  ])

  const settings: SliderSettings = {
    speed: 300,
    variableWidth: true,
    arrows: false,
    infinite: false,
    afterChange: setPosition
  }

  const handleNext = () => sliderRef.current?.slickNext()

  const handlePrev = () => sliderRef.current?.slickPrev()

  return (
    <>
      {(isFilters && isLargerThanHDWithFilters) ||
      (!isFilters && isLargerThanHD) ? (
        <Flex
          flexDirection="row"
          justifyContent="center"
          borderBottom="1px solid #e6e6e6"
        >
          <Flex>{children}</Flex>
        </Flex>
      ) : (
        <section
          className="cards-slider-default"
          style={{
            borderBottom: '1px solid #e6e6e6'
          }}
        >
          <>
            <Slider ref={sliderRef} {...settings}>
              {children}
            </Slider>

            <Box pos="absolute" top="50%" left={0} transform="translateY(-50%)">
              <ScaleFade initialScale={0.9} in={position > 0} unmountOnExit>
                <IconButton
                  size="xs"
                  variant="unstyled"
                  colorScheme="yellow"
                  aria-label="Anterior"
                  icon={<FaAngleLeft />}
                  fontSize={24}
                  display="flex"
                  onClick={handlePrev}
                  transition="all ease .3s"
                  _hover={{
                    fontSize: 20,
                    display: 'flex',
                    justifyContent: 'center',
                    background: '#fad95488'
                  }}
                />
              </ScaleFade>
            </Box>

            {!isLargerThanHDWithFilters && position !== 2 && (
              <Box
                pos="absolute"
                top="50%"
                right={0}
                transform="translateY(-50%)"
              >
                <ScaleFade initialScale={0.9} in={position < 6} unmountOnExit>
                  <IconButton
                    size="xs"
                    variant="unstyled"
                    colorScheme="yellow"
                    aria-label="Posterior"
                    icon={<FaAngleRight />}
                    fontSize={24}
                    display="flex"
                    onClick={handleNext}
                    transition="all ease .3s"
                    _hover={{
                      fontSize: 20,
                      display: 'flex',
                      justifyContent: 'center',
                      background: '#fad95488'
                    }}
                  />
                </ScaleFade>
              </Box>
            )}
          </>
        </section>
      )}
    </>
  )
}

export default CardSlider
